import type { TenantContext } from '@atlassian/jira-shared-types/src/tenant-context.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createContainer, createHook, createSubscriber } from '@atlassian/react-sweet-state';
import * as actions from '../../actions/index.tsx';
import Store from '../../store.tsx';
import type { Actions, ContainerProps, State } from '../../types.tsx';

export const TenantContextContainer = createContainer<State, Actions, ContainerProps>(Store, {
	onInit:
		() =>
		({ dispatch }) =>
			dispatch(actions.bootstrap()),
});

export const TenantContextSubscriber = createSubscriber<State, Actions>(Store, {
	displayName: 'TenantContextSubscriber',
});

/**
 * @deprecated use individual hooks for the specific things you want.
 * @see module:allTenantContextHooks
 */
export const useTenantContextHook = createHook(Store);

/**
 * @deprecated use individual hooks for the specific things you want.
 * @see module:allTenantContextHooks
 */
export const useTenantContext = (): TenantContext => {
	const [{ tenantContext }] = useTenantContextHook();

	return tenantContext;
};
